(() => {
  'use strict';
  const config = document.getElementById('PKBOptionTranslations');
  if (!config || document.documentElement.lang.split('-')[0] !== 'en') return;
  let translations;
  try {
    translations = JSON.parse(config.textContent);
  } catch {
    return;
  }
  const roots = new WeakSet();
  function translate(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement?.closest('label, legend, option, .spb-label-tooltip')) continue;
      const source = node.nodeValue.trim();
      if (Object.prototype.hasOwnProperty.call(translations, source)) {
        const target = translations[source];
        if (typeof target === 'string' && target !== source) {
          node.nodeValue = node.nodeValue.replace(source, () => target);
        }
      }
    }
  }
  function install() {
    const root = document.getElementById('infiniteoptions-container');
    if (!root || roots.has(root)) return;
    roots.add(root);
    translate(root);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        translate(root);
      });
    }).observe(root, {childList: true, subtree: true, characterData: true});
  }
  install();
  new MutationObserver(install).observe(document.body, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', install);
})();
